// German-aware slug for file names: readable, lowercase, ASCII-only.
// Stricter than the backend's `[^a-zA-Z0-9.\-] -> _` sanitiser on purpose —
// voice actors and importers should be able to read the name at a glance.
const UMLAUT_MAP: Record<string, string> = {
  ä: 'ae',
  ö: 'oe',
  ü: 'ue',
  ß: 'ss',
  Ä: 'ae',
  Ö: 'oe',
  Ü: 'ue'
}

export function slugify (input: string): string {
  return (input || '')
    .replace(/[äöüßÄÖÜ]/g, (ch) => UMLAUT_MAP[ch] ?? ch)
    .normalize('NFKD') // split remaining accents (é -> e + ´)
    .replace(/[̀-ͯ]/g, '') // drop combining accents
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-') // anything else -> hyphen
    .replace(/-+/g, '-') // collapse repeats
    .replace(/^-|-$/g, '') // trim edge hyphens
}
